import { render, staticRenderFns } from "./Unterschriften.vue?vue&type=template&id=69a96ca1&"
import script from "./Unterschriften.vue?vue&type=script&lang=js&"
export * from "./Unterschriften.vue?vue&type=script&lang=js&"
import style0 from "./Unterschriften.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports